import { render, staticRenderFns } from "./PedidoPage.vue?vue&type=template&id=600cb290&lang=pug&"
import script from "./PedidoPage.ts?vue&type=script&lang=ts&"
export * from "./PedidoPage.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports